
const headers = [
    {
      label: 'ชื่อ-นามสกุล',
      field: 'fullname',
    },
    {
      label: 'เรื่องร้องทุกข์',
      field: 'total',
    },
    {
      label: 'Action',
      field: 'action',
      tdClass: 'text-center',
    },
  ]

  export default headers